import { IGetFornecedoresFamiliasDropDownUseCase } from "../../../presentation/useCases/read/get_fornecedores_familias_drop_down_use_case";
import { FornecedorFamiliaDropDown } from "../../models/fornecedor_familia_dropdown";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedoresFamiliasDropDownUseCase
 */

export class GetFornecedoresFamiliasDropDownUseCase implements IGetFornecedoresFamiliasDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedoresFamiliasDropDown(): Promise<FornecedorFamiliaDropDown[]> {
    return await this.repository.getFornecedoresFamiliasDropDown();
  }
}
